import { useFormContext, Controller } from 'react-hook-form';
import { Tabs, Tab, Box, Typography, FormControl, FormHelperText } from '@mui/material';

type Props = {
  name: string;
  options: { label: string; value: any }[];
  label?: string;
  helperText?: React.ReactNode;
};

export default function RHFTabs({
  name,
  label,
  options,
  helperText,
  ...other
}: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl component="fieldset" error={!!error}>
          {label && (
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Typography variant="overline">{label}</Typography>
            </Box>
          )}

          <Tabs
            {...field}
            onChange={(event, newValue) => {
              field.onChange(newValue);
            }}
            variant="scrollable"
            scrollButtons="auto"
            {...other}
          >
            {options.map((option, index) => (
              <Tab
                key={option.value}
                label={option.label}
                value={option.value}
              // Если используется индекс в качестве value, то необходимо `value={index}`
              />
            ))}
          </Tabs>

          {(!!error || helperText) && (
            <FormHelperText sx={{ mx: 0 }}>
              {error ? error.message : helperText}
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}
